// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WellMappingTable__mappingTableContainer___C9CeB {
    --table-border: 0.1rem solid var(--color-bg-border);

    position: relative;

    width: 45%;
    min-width: 60rem;
    max-width: 70%;

    /* фиксируется растяжение по высоте родителя */
    height: 100%;
    min-height: 100%;
    max-height: 100%;

    color: var(--color-typo-primary);
}

.WellMappingTable__mappingTable___V775n {
    position: absolute;

    width: 100.1%; /* убирает косяк c фантомным горизонтальным скролом */

    font-size: var(--size-text-m);

    border: var(--table-border);
    border-radius: 0.4rem;
}

.WellMappingTable__mappingTable___V775n table {
    border-spacing: 0;
}

.WellMappingTable__mappingTable___V775n th {
    text-transform: uppercase;
}

/* stylelint-disable-next-line selector-class-pattern -- Класс RC Table */
.WellMappingTable__mappingTable___V775n .rc-table-header {
    border-bottom: var(--table-border);
}

/* stylelint-disable-next-line selector-class-pattern -- Класс RC Table */
.WellMappingTable__mappingTable___V775n .rc-table-header .rc-table-cell:not(:last-child) {
    border-right: var(--table-border);
}

.WellMappingTable__mappingTableRow___OgS0e {
    display: flex;
    align-items: stretch;
    border-bottom: var(--table-border);
}

.WellMappingTable__mappingTableRow___OgS0e:hover {
    background-color: var(--color-control-bg-clear-hover);
}

.WellMappingTable__mappingTableRow___OgS0e > div:not(:last-child) {
    box-sizing: border-box;
    border-right: var(--table-border);
}

.WellMappingTable__sourceWellColumn___MhzjT {
    overflow: hidden;

    padding: 0.8rem;

    text-align: left;
    text-overflow: ellipsis;
    text-wrap: nowrap;
}

.WellMappingTable__mappedWellColumn___ZPWwc {
    padding-right: 0.8rem;
    padding-left: 0.8rem;
    text-align: left;
}

.WellMappingTable__mappingUnmapped___Z9viN {
    background-color: rgba(235 87 87 / 15%);
}

.WellMappingTable__mappingStatusIcon___eTogE {
    margin: 1.2rem;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/MasterImport/MarkersImport/Mapping/WellMappingTable.css"],"names":[],"mappings":"AAAA;IACI,mDAAmD;;IAEnD,kBAAkB;;IAElB,UAAU;IACV,gBAAgB;IAChB,cAAc;;IAEd,8CAA8C;IAC9C,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;;IAEhB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;;IAElB,aAAa,EAAE,qDAAqD;;IAEpE,6BAA6B;;IAE7B,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,yEAAyE;AACzE;IACI,kCAAkC;AACtC;;AAEA,yEAAyE;AACzE;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,kCAAkC;AACtC;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;;IAEhB,eAAe;;IAEf,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".mappingTableContainer {\n    --table-border: 0.1rem solid var(--color-bg-border);\n\n    position: relative;\n\n    width: 45%;\n    min-width: 60rem;\n    max-width: 70%;\n\n    /* фиксируется растяжение по высоте родителя */\n    height: 100%;\n    min-height: 100%;\n    max-height: 100%;\n\n    color: var(--color-typo-primary);\n}\n\n.mappingTable {\n    position: absolute;\n\n    width: 100.1%; /* убирает косяк c фантомным горизонтальным скролом */\n\n    font-size: var(--size-text-m);\n\n    border: var(--table-border);\n    border-radius: 0.4rem;\n}\n\n.mappingTable table {\n    border-spacing: 0;\n}\n\n.mappingTable th {\n    text-transform: uppercase;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- Класс RC Table */\n.mappingTable :global(.rc-table-header) {\n    border-bottom: var(--table-border);\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- Класс RC Table */\n.mappingTable :global(.rc-table-header) :global(.rc-table-cell):not(:last-child) {\n    border-right: var(--table-border);\n}\n\n.mappingTableRow {\n    display: flex;\n    align-items: stretch;\n    border-bottom: var(--table-border);\n}\n\n.mappingTableRow:hover {\n    background-color: var(--color-control-bg-clear-hover);\n}\n\n.mappingTableRow > div:not(:last-child) {\n    box-sizing: border-box;\n    border-right: var(--table-border);\n}\n\n.sourceWellColumn {\n    overflow: hidden;\n\n    padding: 0.8rem;\n\n    text-align: left;\n    text-overflow: ellipsis;\n    text-wrap: nowrap;\n}\n\n.mappedWellColumn {\n    padding-right: 0.8rem;\n    padding-left: 0.8rem;\n    text-align: left;\n}\n\n.mappingUnmapped {\n    background-color: rgba(235 87 87 / 15%);\n}\n\n.mappingStatusIcon {\n    margin: 1.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mappingTableContainer": `WellMappingTable__mappingTableContainer___C9CeB`,
	"mappingTable": `WellMappingTable__mappingTable___V775n`,
	"mappingTableRow": `WellMappingTable__mappingTableRow___OgS0e`,
	"sourceWellColumn": `WellMappingTable__sourceWellColumn___MhzjT`,
	"mappedWellColumn": `WellMappingTable__mappedWellColumn___ZPWwc`,
	"mappingUnmapped": `WellMappingTable__mappingUnmapped___Z9viN`,
	"mappingStatusIcon": `WellMappingTable__mappingStatusIcon___eTogE`
};
export default ___CSS_LOADER_EXPORT___;
